var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "@irati/ui/src/Layout/Card";
import Form from "@irati/ui/src/Form";
import Loading from "@irati/ui/src/Loading";
import { ValidationButton } from "@irati/ui/src/FormItem";
import { H1 } from "@irati/ui/src/Typography";
import { changePassword } from "@irati/auth/services/password";
import PasswordSavedModal from "@irati-web/platform/src/components/PasswordSavedModal/PasswordSavedModal";
import History from "@irati/utils/history";
import authentication from "@irati/auth";
import { Password } from "@irati-web/fields/user";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import SetPasswordError from "@irati/ui/src/SetPasswordError";
import Flex from "@irati/ui/src/Flex";
var UpdateUserPassword = /** @class */ (function (_super) {
    __extends(UpdateUserPassword, _super);
    function UpdateUserPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            saved: false
        };
        _this.handleChange = function (label, value) {
            var _a;
            _this.setState((_a = {},
                _a[label] = value,
                _a.load = undefined,
                _a));
        };
        _this.handleSubmit = function () {
            var _a = _this.state, oldPassword = _a.oldPassword, newPassword = _a.newPassword;
            var user = authentication.user();
            if (!oldPassword || !newPassword)
                return;
            var load = changePassword(user, oldPassword, newPassword).then(function () {
                _this.setState({
                    saved: true
                });
                setTimeout(function () {
                    _this.setState({
                        saved: false
                    });
                    History.replace({
                        pathname: "/profile"
                    }, _this.context);
                }, 3000);
            });
            _this.setState({ load: load });
        };
        _this.handleHide = function () {
            _this.setState({ saved: false });
        };
        return _this;
    }
    UpdateUserPassword.prototype.render = function () {
        var _this = this;
        var _a = this.state, oldPassword = _a.oldPassword, newPassword = _a.newPassword, confirmPassword = _a.confirmPassword, load = _a.load, saved = _a.saved;
        var formatMessage = this.props.formatMessage;
        var isManagedExternally = authentication.user().isManagedExternally;
        if (isManagedExternally) {
            return (React.createElement(Card, { tiny: true, noBorder: true },
                React.createElement(H1, null,
                    React.createElement(FormattedMessage, { id: "account.password.sso" }))));
        }
        return (React.createElement(Card, { tiny: true, noBorder: true },
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "account.password.headerTwo.changePassword" })),
            React.createElement(Flex, { direction: "column", maxWidth: "480px", justifyContent: "flex-start" },
                React.createElement(Form, null,
                    React.createElement(Password, { name: "old-password", label: formatMessage({ id: "account.password.fields.current.label" }), placeholder: formatMessage({ id: "account.password.fields.current.placeholder" }), value: oldPassword, noValidation: true, isRequired: true, onChange: function (value) { return _this.handleChange("oldPassword", value); } }),
                    React.createElement(Password, { name: "new-password", label: formatMessage({ id: "account.password.fields.new.label" }), placeholder: formatMessage({ id: "account.password.fields.new.placeholder" }), value: newPassword, hint: formatMessage({ id: "platform.password.hint" }), onChange: function (value) { return _this.handleChange("newPassword", value); } }),
                    React.createElement(Password, { name: "confirmPassword", label: formatMessage({ id: "account.password.fields.confirm.label" }), placeholder: formatMessage({ id: "account.password.fields.confirm.placeholder" }), value: confirmPassword, onChange: function (value) { return _this.handleChange("confirmPassword", value); }, passwordToMatch: this.state.newPassword }),
                    React.createElement(Loading, { load: load, useLoader: false }),
                    React.createElement(Loading, { load: load, Error: SetPasswordError, useLoader: false }),
                    React.createElement(ValidationButton, { large: true, primary: true, load: load, onClick: this.handleSubmit, marginTop: 1 },
                        React.createElement(FormattedMessage, { id: "account.password.changeButton" })))),
            saved && React.createElement(PasswordSavedModal, { onHide: this.handleHide })));
    };
    UpdateUserPassword.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return UpdateUserPassword;
}(Component));
export default injectIntl(UpdateUserPassword);
